// STYLED COMPONENTS
import styled from "styled-components";

// HOOKS
import { useHistory } from "react-router-dom";

export enum ILinkType {
  DEFAULT = "DEFAULT",
  ERROR = "ERROR",
}

interface ILinkProps {
  children: string;
  path?: string;
  type?: ILinkType;
  navigateTo?: (path?: string) => void;
}

const LinkText = styled.a<{ linktype: ILinkType }>`
  cursor: pointer;
  text-decoration: underline;
  color: ${({ linktype }) =>
    linktype === ILinkType.ERROR ? "#cc0000" : "inherit"}; // Dynamic color based on type
`;

/**
 * A styled link component that can be used to render a link with an underline.
 *
 * @function
 * @param {string} children - The text to display in the link.
 * @param {string} path - The path to navigate to when the link is clicked.
 * @param {ILinkType} type - The type of link to render.
 * @param {() => void} navigateTo - A function to call when the link is clicked.
 * @returns {JSX.Element} The JSX code to render the StyledLink component.
 */
export const StyledLink = ({
  children,
  path,
  type = ILinkType.DEFAULT,
  navigateTo,
}: ILinkProps): JSX.Element => {
  const history = useHistory();

  const handleClick = () => {
    if (navigateTo) {
      navigateTo(path);
    } else if (path) {
      history.push(path);
    }
  };

  return (
    <LinkText onClick={handleClick} linktype={type}>
      {children}
    </LinkText>
  );
};
